import { define } from "../preactement/define";
import { attributes } from "./shared-attributes";
import { MenuIconThin } from "../../Icons";
import { parseBooleanAttr } from "../wrapperUtils";

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const Wrapper = _ref => {
  let {
    ariaHidden,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(MenuIconThin, {
    ariaHidden: parseBooleanAttr(ariaHidden),
    ...otherProps
  });
};
define('ds-menu-icon-thin', () => Wrapper, {
  attributes
});